import { useContext, useState } from 'react';
import { List, ListItemButton, ListItemText, Menu, MenuItem } from '@mui/material';
import { MdAccountCircle as UserMenuIcon, MdExitToApp as LogoutIcon } from 'react-icons/md';
import { appUserContext } from 'helpers/services';


let UserMenu = () => {
    let { currentUser, signOut } = useContext(appUserContext);

    let [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    let logout = async () => {
        setAnchorEl(null);
        await signOut();
    }


    return (
        <>
            <List
                component="nav"
                disablePadding
                style={{ display: 'flex' }}
            >
                <ListItemButton onClick={(e) => setAnchorEl(e.currentTarget)}>
                    <ListItemText primary={<UserMenuIcon />} />
                </ListItemButton>
            </List>

            <Menu
                anchorEl={anchorEl}
                keepMounted
                open={anchorEl !== null}
                onClose={() => setAnchorEl(null)}
            >
                <MenuItem disabled>{currentUser?.email}</MenuItem>
                <MenuItem onClick={logout}>
                    <LogoutIcon />&nbsp;&nbsp;Logout
                </MenuItem>
            </Menu>
        </>
    )
}

export default UserMenu;